import type { SearchConfig } from '@eliadmin/core/src/components/header/search-bar/search-config-types';

export const SEARCH_CONFIG: SearchConfig = {
  mode: 'drawer',
  sections: ['products'],
  productQuery: { attributes: true },
};
